import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIsMobileDevice } from '../../../../hooks';
import { TDispatch } from '../../../../redux';
import { openAuction } from '../../../../redux/reducers';
import { selectIsAuctionEnabled, selectIsAutobrokerEnabled } from '../../../../selectors/auction';
import { trackAuctionOpen } from '../../../../tracking';
import { ActionButtonsMobile } from './ActionButtonsMobile';

export let isAuctionOpenedFirstTime = true;

export const ActionButtonsMobileContainer = () => {
  const isMobile = useIsMobileDevice();

  const isAuctionEnabled = useSelector(selectIsAuctionEnabled);
  const isAutobrokerEnabled = useSelector(selectIsAutobrokerEnabled);

  const dispatch = useDispatch<TDispatch>();

  const handleAuctionButtonClick = React.useCallback(() => {
    dispatch(openAuction());

    if (isAuctionOpenedFirstTime) {
      trackAuctionOpen(isAutobrokerEnabled);

      isAuctionOpenedFirstTime = false;
    }
  }, [dispatch, isAuctionOpenedFirstTime, isAutobrokerEnabled]);

  if (!isMobile) {
    return null;
  }

  return <ActionButtonsMobile isAuctionEnabled={isAuctionEnabled} onAuctionButtonClick={handleAuctionButtonClick} />;
};
